<template lang="pug">
  div.file-loader
    input(
      ref="input"
      type="file"
      :accept="accept"
      @click="clearValue"
      @input="onFileLoad"
      @dragenter="dragenter"
      @dragleave="dragleave"
      @drop="drop"
    ).file-input
    slot
</template>

<script>
export default {
  props: {
    accept: {
      type: String,
      default: ''
    }
  },
  methods: {
    onFileLoad(e) {
      const file = e.target.files[0];
      if (file) {
        this.$emit('onFileLoad', file);
        e.target.value = null;
      }
    },
    clearValue() {
      this.$refs.input.value = null;
    },
    dragenter() {
      this.$emit('onDragOver', true);
    },
    dragleave() {
      this.$emit('onDragOver', false);
    },
    drop() {
      this.$emit('onDragOver', false);
    }
  }
}
</script>
<style lang="scss" scoped>
.file-loader {
  position: relative;
  display: inline-block;
}
.file-input {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 1;
  cursor: pointer;
}
</style>